import { Link } from "react-router-dom";

const SERVICES = [
  {
    name: "Wordy Whiz",
    body: "Our own product, not a client's: a vocabulary trainer and letter-drop word game, built and run in-house.",
  },
  {
    name: "Consulting",
    body: "Full-stack data consulting: architecture, ingestion, modeling, and analysis.",
  },
  {
    name: "Mobile App Development",
    body: "iOS and Android apps built end to end, from a first prototype through App Store launch and the releases after that.",
  },
];

function About() {
  return (
    <div className="practice-page">
      <p className="practice-eyebrow">About Good Distractions</p>
      <h1 className="practice-headline">
        A small studio that builds mobile apps, <em>including our own.</em>
      </h1>
      <p className="practice-body">
        Good Distractions LLC is a mobile app development and consulting
        practice. We design and build apps for other teams, and we keep a
        product of our own in active development (Wordy Whiz, a vocabulary
        trainer and word game), so the advice we give is grounded in
        software we actually ship and maintain ourselves.
      </p>

      <div className="practice-services">
        {SERVICES.map((s) => (
          <div key={s.name} className="practice-service">
            <h3>{s.name}</h3>
            <p>{s.body}</p>
          </div>
        ))}
      </div>

      <div className="practice-actions">
        <Link to="/contact" className="practice-cta">Work with us →</Link>
        <Link to="/" className="practice-secondary">See Wordy Whiz</Link>
      </div>
    </div>
  );
}

export default About;
